import TrackingScripts from "./scripts.js";

export default TrackingScripts;
